var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
var Switcher = function (props) {
    return (_jsxs("div", __assign({ onClick: props.onclick, className: 'toggle-block' }, { children: [_jsx("p", { children: props.switcherTxt }), _jsx("div", __assign({ className: 'toggle-div' }, { children: _jsx("div", { className: props.class }) }))] })));
};
Switcher.propTypes = {
    onclick: PropTypes.func.isRequired,
    class: PropTypes.string.isRequired,
    switcherTxt: PropTypes.any.isRequired,
};
export default Switcher;



// WEBPACK FOOTER //
// ./src/components/sidebar/Switcher.jsx